import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import { Quad } from '@marmon/shared/types/quad';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-quad-revenue-percent-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class QuadRevenuePercentCellComponent extends ColorCodeCellBase<number> {
	readonly toValue = inject(PercentToValuePipe);

	override readonly formattedValue = computed(() =>
		this.toValue.transform(this.value()),
	);

	readonly box = input.required<Quad>();

	override getColorCode(value: number): CellColorCode {
		const quad = this.box() - 1;
		const targets = [0.64, 0.16, 0.16, 0.04] as const;

		const target = targets[quad];
		const delta = value - target;
		switch (quad) {
			case 0:
				if (delta >= 0) return 'green';
				if (delta >= -0.02) return 'yellow';
				return 'red';
			case 1:
			case 2: {
				const absDelta = Math.abs(delta);
				if (absDelta <= 0.01) return 'green';
				if (absDelta <= 0.02) return 'yellow';
				return 'red';
			}
			case 3:
				if (delta <= 0) return 'green';
				if (delta <= 0.01) return 'yellow';
				return 'red';
			default:
				return 'gray';
		}
	}
}
